import React, { Component, Fragment } from "react";
import ComponentHeader from "./ComponentHeader";
import classnames from "classnames";
import styles from "./Components.local.scss";
import { number_format } from "Utils";
import { SvgIcon } from "../../Common/Icons";
import Percentage from "../../Common/Percentage/Percentage";
import ComponentActions from "./ComponentActions";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  BarChart,
  Bar,
  LabelList,
  ReferenceLine,
  Legend,
  Tooltip
} from "recharts";
import { Modal } from "antd";
import {
  COLORS,
  CustomizedYAxisTick,
  CustomTooltip
} from "../../Common/Charts/Common";
import { CustomizedLabel } from "../../Common/Charts/StandardBarChart";

class TrafficLightAndValuesComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      chartData: []
    };

    this.handleBarClick = this.handleBarClick.bind(this);
  }

  handleBarClick = data => {
    const chartData = Object.entries(data).map(([year, data]) => {
      const children = Object.values(data.children).filter(
        child => child.label !== ""
      );
      const result = { year };
      children.forEach(child => {
        result[child.label] = child.value;
      });
      return result;
    });
    console.log("==", chartData);

    // console.log("==", chartData);

    this.setState({
      showModal: true,
      chartData
    });
  };

  handleClose = () => {
    this.setState({
      showModal: false,
      chartData: []
    });
  };

  renderInnerBarChart() {
    const { chartData } = this.state;
    const labels = [
      ...new Set(
        chartData.flatMap(item =>
          Object.keys(item).filter(key => key !== "year")
        )
      )
    ];

    if (!chartData.length) {
      return null;
    }

    return (
      <Modal
        visible={this.state.showModal}
        onOk={this.handleClose}
        onCancel={this.handleClose}
        width={1200}
        bodyStyle={{ maxHeight: "90vh", overflowY: "auto" }}
        footer={null}
      >
        <ResponsiveContainer width="100%" height={550}>
          <BarChart data={chartData}>
            <Legend
              layout="horizontal"
              verticalAlign="top"
              align="center"
              height={100}
              payload={
                labels &&
                labels.map((entry, index) => ({
                  value: entry,
                  type: "square",
                  color: COLORS[index % COLORS.length]
                }))
              }
            />
            <Tooltip
              cursor={{ fill: "#f3faff", opacity: 0.6 }}
              content={<CustomTooltip />}
            />
            <CartesianGrid
              vertical={false}
              stroke="#6d7f92"
              strokeWidth={0.2}
            />
            <XAxis dataKey="year" axisLine={false} />
            <YAxis
              tick={<CustomizedYAxisTick currency="€" />}
              axisLine={false}
              tickLine={false}
              type={"number"}
            />
            {labels.map((label, index) => (
              <Bar
                key={label}
                dataKey={label}
                fill={COLORS[index % COLORS.length]}
                minPointSize={2}
              >
                <LabelList
                  dataKey="label"
                  position="top"
                  payload
                  content={<CustomizedLabel />}
                />
              </Bar>
            ))}
            {/* <LabelList
              dataKey="value"
              position="top"
              payload
              content={<CustomizedLabel chartData={chartData} />}
            />
          </Bar> */}
            <ReferenceLine y={0} stroke="#00000080" strokeWidth={1} />
          </BarChart>
        </ResponsiveContainer>
      </Modal>
    );
  }
  render() {
    const {
      slideId,
      isPreparePresentation,
      component,
      isComposition,
      isPresentation,
      hasComments,
      hasExplanation,
      indicatorsExplanation
    } = this.props;
    const {
      componentId,
      labels,
      data: { account },
      config: { annexeAttachmentCategory }
    } = component;

    const {
      percentage,
      currentValue,
      diffValue,
      lastYearValue,
      unit,
      notAvailable
    } = account[0];

    return (
      <Fragment>
        <div
          className={classnames(
            styles.TrafficLightAndValues_Background,
            percentage < -5
              ? styles.red_light_background
              : percentage < 0
                ? styles.orange_light_background
                : styles.blue_light_background
          )}
          onClick={() => this.handleBarClick(account[0].data)}
        >
          <ComponentHeader
            slideId={slideId}
            percentage={""}
            title={labels}
            annexeAttachmentCategory={annexeAttachmentCategory}
            handleDisplayAnnexePDF={this.props.handleDisplayAnnexePDF}
            isComposition={isComposition}
            isPresentation={isPresentation}
            hasComments={hasComments}
            componentId={componentId}
            isPreparePresentation={isPreparePresentation}
            indicatorsExplanation={indicatorsExplanation}
            hasExplanation={hasExplanation}
            inSlideView={this.props.inSlideView}
          />
          <div
            className={classnames(
              styles.TrafficLightAndValuesComponent,
              styles.flex_container,
              styles.align_container
            )}
          >
            {!this.props.inSlideView &&
              !this.props.isEmbedded && (
                <ComponentActions
                  removeComponent={this.props.handleRemoveComponent}
                  updateComponent={this.props.handleUpdateComponent}
                  componentCase={this.props.ComponentCase}
                  sideBar={"ComponentConfig"}
                  component={"TrafficLightAndValuesComponent.png"}
                />
              )}
            <div
              className={classnames(
                "medium-12 small-12",
                styles.flex_container,
                styles.align_container
              )}
            >
              <div
                className={classnames(
                  "medium-10 small-10",
                  styles.flex_container,
                  styles.align_container
                )}
                style={{ justifyContent: "flex-end" }}
              >
                <span
                  className={classnames(
                    "medium-11 small-11",
                    styles.main_value
                  )}
                >
                  {notAvailable
                    ? currentValue
                    : number_format(currentValue, 2, ",", " ")}{" "}
                  {unit !== "none" ? unit : ""}
                </span>

                <div
                  className={classnames(
                    "medium-11 small-11",
                    styles.flex_container,
                    styles.align_container,
                    styles.sub_container
                  )}
                >
                  <div className={"medium-1 small-1"} style={{ marginTop: 5 }}>
                    <SvgIcon
                      icon={
                        percentage >= 0
                          ? "ProfitBarChartIcon"
                          : "DeficitBarChartIcon"
                      }
                      className={""}
                    />
                  </div>
                  <div
                    className={classnames(
                      "medium-6 small-6",
                      styles.flex_container,
                      styles.align_container,
                      styles.separator
                    )}
                  >
                    <span
                      className={classnames(
                        "medium-12 small-12",
                        styles.diff_value
                      )}
                    >
                      {percentage >= 0 ? "+ " : "- "}
                      {number_format(diffValue, 2, ",", " ")}{" "}
                      {unit !== "none" ? unit : ""}
                    </span>
                    <span
                      className={classnames(
                        "medium-12 small-12",
                        styles.percentage_value
                      )}
                    >
                      <Percentage percentage={percentage} />
                    </span>
                  </div>
                  <div
                    className={classnames(
                      "medium-5 small-5",
                      styles.flex_container,
                      styles.align_container,
                      styles.last_year_bloc
                    )}
                  >
                    <span className={"medium-3 small-3"}>N-1 : </span>
                    <span
                      className={classnames(
                        "medium-7 small-7",
                        styles.last_year_value
                      )}
                    >
                      {number_format(lastYearValue, 2, ",", " ")}{" "}
                      {unit !== "none" ? unit : ""}
                    </span>
                  </div>
                </div>
              </div>
              <div className={classnames("medium-2 small-2")} />
            </div>
            <div
              className={classnames(
                styles.traffic_light,
                styles.flex_container
              )}
            >
              <SvgIcon
                icon={"TrafficLight"}
                className={classnames(styles.traffic_light_icon)}
              />
            </div>
          </div>
        </div>
        {this.renderInnerBarChart()}
      </Fragment>
    );
  }
}

export default TrafficLightAndValuesComponent;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Components/TrafficLightAndValuesComponent.js